import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

/**
 * 一覧の絞り込み。
 *
 * 件数が増えると目的の行に辿り着けなくなるので、一覧の頭に置く。
 * サーバーには問い合わせず、取得済みの行を絞るだけ (粒度が粗く、
 * 1 テナントの行数がページングを要るほど増えない前提)。
 */
export function SearchInput({
  value,
  onChange,
  placeholder = '絞り込む',
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}) {
  return (
    <Input
      type="search"
      role="searchbox"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
      className={cn('w-64', className)}
    />
  );
}

/** 表記ゆれ (大文字小文字・前後の空白) を吸収して部分一致で照合する */
export function matchesQuery(query: string, ...fields: Array<string | null | undefined>): boolean {
  const needle = query.trim().toLowerCase();
  if (needle === '') return true;
  return fields.some((field) => (field ?? '').toLowerCase().includes(needle));
}
